import EvidenceActions from './EvidenceActions';
import ReconciliationHistory from './ReconciliationHistory';
import ReconciliationWorkStatus from './ReconciliationWorkStatus';
import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { getCapabilities } from '../../../../services/ReconciliationActionService';
import { supportsBankReconciliation } from '../../../../services/MatchingService.contract';
import { buildConfirmTargets } from '../../../../services/MatchingService';
import useInvoiceSettlement from './useInvoiceSettlement';
import InvoicePickerModal from './InvoicePickerModal';
import ActionPreview from './ActionPreview';
import BankPaymentLink from './BankPaymentLink';
export default function ReconciliationWorkspace({ companyId, line, onSettled, children }) {
    const [enabled,setEnabled] = useState(false), [open,setOpen] = useState(false);
    const [evidenceEnabled,setEvidenceEnabled] = useState(false);
    const [needsRefresh,setNeedsRefresh] = useState(false);
    const settlement=useInvoiceSettlement({companyId,line,onSettled:() => setNeedsRefresh(true)});
    const close = () => {
        if(settlement.busy || settlement.unknown) return;
        setOpen(false);
        if(needsRefresh || settlement.result) onSettled?.();
    };
    useEffect(() => {let active=true;getCapabilities(companyId).then(c => {if(active){setEnabled(supportsBankReconciliation(c));setEvidenceEnabled(c.actions?.includes('attach_evidence') && c.actions?.includes('link_existing_verification'));}}).catch(() => {if(active)setEnabled(false);});return () => {active=false;};},[companyId]);
    const confirm = (suggestion,options) => {
        const invoiceTarget=buildConfirmTargets(suggestion).some(t => ['customer_invoice','supplier_invoice'].includes(t.target_type));
        if(enabled && invoiceTarget) {setOpen(true);return;}
        return children.props.onConfirmSuggestion(suggestion,options);
    };
    return <>
        {enabled && <ReconciliationWorkStatus companyId={companyId} line={line}/>}
        {enabled && <ReconciliationHistory companyId={companyId} statementId={line.id} onChanged={onSettled}/>}
        {React.cloneElement(children,{onConfirmSuggestion:confirm})}
        {enabled && <div className="border-top p-3"><Button variant="outline-primary" onClick={() => setOpen(true)} disabled={line.reconciliation_status === 'verified' && !settlement.plan && !settlement.unknown}>Välj faktura eller registrerad betalning</Button>{evidenceEnabled && <EvidenceActions companyId={companyId} line={line} onChanged={onSettled}/>}</div>}
        <Modal show={open} onHide={close} size="lg" centered>
            <Modal.Header closeButton={!settlement.busy && !settlement.unknown}><Modal.Title>Stäm av betalning</Modal.Title></Modal.Header>
            <Modal.Body>
                {settlement.error && <Alert variant="warning">{settlement.error}</Alert>}
                {settlement.result ? <BankPaymentLink companyId={companyId} plan={settlement.plan} result={settlement.result} onShowVerification={async () => {setOpen(false);await children.props.onShowVerification?.();onSettled?.();}} /> : settlement.plan
                    ? <ActionPreview {...settlement} onExecute={settlement.execute} onEdit={settlement.clear} />
                    : <InvoicePickerModal companyId={companyId} line={line} busy={settlement.busy || settlement.unknown} onPick={settlement.prepare} />}
            </Modal.Body>
        </Modal>
    </>;
}
